import { defineStore } from 'pinia'

export const useRootStore = defineStore('root', {
  namespaced: true,
  state: () => {
    return {
      currentDomain: null,
      isEnDomain: false,
      queryParams: {},
      hiddenFrequencies: [],
      appeal: null,
      validation: {
        paymentMethodSelect: false,
        form: false
      },
      validateAllFields: false,
      turnstileToken: null
    }
  },
  getters: {
    formValid: state => {
      return Object.values(state.validation).every(item => item === true)
    }
  },
  actions: {
    setCurrentDomain (payload) { this.currentDomain = payload },
    setIsEnDomain (payload) { this.isEnDomain = payload },
    setHiddenFrequencies (payload) { this.hiddenFrequencies = Array.isArray(payload) ? payload : (payload ? [payload] : []) },
    setAppeal (payload) { this.appeal = payload },
    setQueryParams (payload) { this.queryParams = payload },
    setValidationPaymentMethodSelect (payload) { this.validation.paymentMethodSelect = payload },
    setValidationForm (payload) { this.validation.form = payload },
    touchValidationFields (payload) { this.validateAllFields = payload },
    setTurnstileToken (payload) { this.turnstileToken = payload }
  }
})
